import React, { useState, useEffect } from "react";
import $ from "jquery";
import ReactStars from "react-rating-stars-component";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import "react-treeview/react-treeview.css";
import {
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { ProfileService } from "../../../../../services/ProfileService";
import { JobService } from "../../../../../services/JobService";
import { Stringutility } from "../../../../../utilities/stringutility";
import { Constants } from "../../../../../constants/constantValues";
import { StorageService } from "../../../../../services/StorageService";
import { StorageValues } from "../../../../../constants/storageValues";

const LanguagesList = (props) => {
  const [modalRight, setModalRight] = useState(false);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [languageshow, setlanguageShow] = useState(true);
  const [categories, setCategories] = useState([]);
  const [modalNested, setmodalNested] = useState(false);

  const [rating, setRating] = useState(0);
  const [selectedSoftSkills, setSelectedSoftSkills] = useState([]);

  const [scategories, setSCategories] = useState([]);

  const [selectedSkills, setSelectedSkills] = useState([]);
  const [writtenSelectedSkills, setWrittenSelectedSkills] = useState([]);

  const [ratingSpokenSelectedList, setRatingSpokenSelectedList] = useState([]);
  const [ratingWriteSelectedList, setRatingWriteSelectedList] = useState([]);

  const [selectedSpokenId, setSelectedSpokenId] = useState([]);
  const [selectedWrittenId, setSelectedWrittenId] = useState([]);

  const [languageId, setLanguageId] = useState("");
  const [languageName, setLanguageName] = useState("");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [saveBtnEnabled, setSaveBtnEnabled] = useState(false);
  const [selectedLanguageId, setSelectedLanguageId] = useState("");
  const [candidateTotLanguages, setCandidateTotLanguages] = useState([]);
  const [profile, setProfile] = useState("");

  useEffect(() => {
    let profile=Stringutility.getValue(StorageService.getFromLocalStorage(StorageValues.PROFILE));
    setProfile(profile);    

    getLanguagesList();
    getCandidateLanguagesList();
  }, []);

  const getLanguagesList = () => {
    JobService.getLanguages(sortOrder).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          let languageDetails = response.data;

          if (languageDetails != null) {
            setCategories(languageDetails.skills);
            setFilteredCategories(languageDetails.skills);
            let languageSkills = languageDetails.skills;
            languageSkills.map((skill, index) => {
              skill.ratingSpoken = 0;
              skill.ratingWritten = 0;
            });

            setCategories(languageDetails.skills);
            setFilteredCategories(languageDetails.skills);
          }
        }
      } catch (err) {}
    });
  };

  const getCandidateLanguagesList = () => {
    ProfileService.getProfileLanguages().then((response) => {
      try {
        if (response.data != null) {
          let languagesList = response.data.languages;
          if (languagesList.length > 0) {
            setCandidateTotLanguages(languagesList);
            setSCategories(languagesList);
          } else {
            setCandidateTotLanguages([]);
            setSCategories([]);
          }
        }
      } catch (err) {
        console.error("getProfileLanguages" + JSON.stringify(err));
      }
    });
  };

  const onSpokenRatingChanged = (newRating, id, index) => {
    let spokenRatingList = [...ratingSpokenSelectedList];
    setRating(newRating);
    for (var i = 0; i < selectedSoftSkills.length; i++) {
      if (selectedSoftSkills[i].skillId == id) {
        selectedSoftSkills[i].ratingSpoken = newRating;
        break;
      }
    }

    if (spokenRatingList.length > 0) {
      const isFound = spokenRatingList.some((element) => {
        if (element.skillId === id) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < spokenRatingList.length; i++) {
          if (spokenRatingList[i].skillId == id) {
            spokenRatingList[i].skillId = id;
            spokenRatingList[i].ratingSpoken = newRating;
            spokenRatingList[i].isSpokenRated = true;
          } else {
            spokenRatingList[i].isSpokenRated = false;
          }
        }
      } else {
        spokenRatingList.push({
          skillId: id,
          ratingSpoken: newRating,
          isSpokenRated: true,
        });
      }
    } else {
      spokenRatingList.push({
        skillId: id,
        ratingSpoken: newRating,
        isSpokenRated: true,
      });
    }
    setRatingSpokenSelectedList(spokenRatingList);

    if (ratingWriteSelectedList.length > 0) {
      let ratingList = [...ratingWriteSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        ratingList[i].isWrittenRated = false;
      }
      setRatingWriteSelectedList(ratingList);
    }

    filteredCategories[index].ratingSpoken = newRating;
    setFilteredCategories(filteredCategories);
  };

  function b(idToSearch, spokenList) {
    if (spokenList.length > 0) {
      return spokenList.filter((item) => {
        return item.skillId === idToSearch;
      });
    }
  }

  const childSpokenHandleCheck = (event, language, index) => {
    var updatedList = [...selectedSkills];
    if (event.target.checked) {
      updatedList.push(language.skillId);

      if (selectedSoftSkills.length > 0) {
        const isFound = selectedSoftSkills.some((element) => {
          if (element.skillId === language.skillId) {
            selectedSpokenId.push({
              skillId: language.skillId,
            });
            return true;
          }
          return false;
        });
        if (isFound) {
          for (let i = 0; i < selectedSoftSkills.length; i++) {
            if (selectedSoftSkills[i].skillId == language.skillId) {
              selectedSoftSkills[i].skillId = language.skillId;
              selectedSoftSkills[i].spoken = true;
              selectedSoftSkills[i].ratingSpoken = 0;
            }
          }
        } else {
          selectedSoftSkills.push({
            skillId: language.skillId,
            spoken: true,
            ratingSpoken: 0,
          });

          selectedSpokenId.push({
            skillId: language.skillId,
          });
        }
      } else {
        selectedSoftSkills.push({
          skillId: language.skillId,
          spoken: true,
          ratingSpoken: 0,
        });
        selectedSpokenId.push({
          skillId: language.skillId,
        });
      }
    } else {
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == language.skillId) {
          updatedList.splice(i, 1);
          selectedSpokenId.splice(i, 1);
        }
      }
      const isFound = selectedSoftSkills.some((element) => {
        if (element.skillId === language.skillId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < selectedSoftSkills.length; i++) {
          if (selectedSoftSkills[i].skillId == language.skillId) {
            selectedSoftSkills[i].spoken = false;
            selectedSoftSkills[i].ratingSpoken = 0;
          }
        }
      }
    }

    if (ratingSpokenSelectedList.length > 0) {
      let ratingList = [...ratingSpokenSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        ratingList[i].isSpokenRated = false;
        if (ratingList[i].skillId == language.skillId) {
          if (!event.target.checked) {
            ratingList[i].ratingSpoken = 0;
          }
        }
      }
      setRatingSpokenSelectedList(ratingList);
    }

    if (ratingWriteSelectedList.length > 0) {
      let ratingList = [...ratingWriteSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        ratingList[i].isWrittenRated = false;
      }
      setRatingWriteSelectedList(ratingList);
    }
    setSelectedSkills(updatedList);

    filteredCategories[index].ratingSpoken = 0;
    setFilteredCategories(filteredCategories);
  };

  const childWrittenHandleCheck = (event, language, index) => {
    var updatedList = [...writtenSelectedSkills];
    if (event.target.checked) {
      updatedList.push(language.skillId);
      if (selectedSoftSkills.length > 0) {
        const isFound = selectedSoftSkills.some((element) => {
          if (element.skillId === language.skillId) {
            selectedWrittenId.push({
              skillId: language.skillId,
            });
            return true;
          }
          return false;
        });
        if (isFound) {
          for (let i = 0; i < selectedSoftSkills.length; i++) {
            if (selectedSoftSkills[i].skillId == language.skillId) {
              selectedSoftSkills[i].skillId = language.skillId;
              selectedSoftSkills[i].written = true;
              selectedSoftSkills[i].ratingWritten = 0;
            }
          }
        } else {
          selectedSoftSkills.push({
            skillId: language.skillId,
            written: true,
            ratingWritten: 0,
          });
          selectedWrittenId.push({
            skillId: language.skillId,
          });
        }
      } else {
        selectedSoftSkills.push({
          skillId: language.skillId,
          written: true,
          ratingWritten: 0,
        });
        selectedWrittenId.push({
          skillId: language.skillId,
        });
      }
    } else {
      const isFound = selectedSoftSkills.some((element) => {
        if (element.skillId === language.skillId) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < selectedSoftSkills.length; i++) {
          if (selectedSoftSkills[i].skillId == language.skillId) {
            selectedSoftSkills[i].written = false;
            selectedSoftSkills[i].ratingWritten = 0;
          }
        }
      }
      for (let i = 0; i < updatedList.length; i++) {
        if (updatedList[i] == language.skillId) {
          updatedList.splice(i, 1);
          selectedWrittenId.splice(i, 1);
        }
      }
    }

    if (ratingWriteSelectedList.length > 0) {
      const ratingList = [...ratingWriteSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        ratingList[i].isWrittenRated = false;
        if (ratingList[i].skillId == language.skillId) {
          if (!event.target.checked) {
            ratingList[i].ratingWritten = 0;
          }
        }
      }
      setRatingWriteSelectedList(ratingList);
    }

    if (ratingSpokenSelectedList.length > 0) {
      const ratingList = [...ratingSpokenSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        ratingList[i].isSpokenRated = false;
      }
      setRatingSpokenSelectedList(ratingList);
    }

    setWrittenSelectedSkills(updatedList);

    filteredCategories[index].ratingWritten = 0;
    setFilteredCategories(filteredCategories);
  };

  const onWriteRatingChanged = (newRating, id, index) => {
    let writtenRatingSelectedList = [...ratingWriteSelectedList];
    setRating(newRating);
    for (var i = 0; i < selectedSoftSkills.length; i++) {
      if (selectedSoftSkills[i].skillId == id) {
        selectedSoftSkills[i].ratingWritten = newRating;
        break;
      }
    }

    if (writtenRatingSelectedList.length > 0) {
      const isFound = writtenRatingSelectedList.some((element) => {
        if (element.skillId === id) {
          return true;
        }
        return false;
      });

      if (isFound) {
        for (let i = 0; i < writtenRatingSelectedList.length; i++) {
          if (writtenRatingSelectedList[i].skillId == id) {
            writtenRatingSelectedList[i].skillId = id;
            writtenRatingSelectedList[i].ratingWritten = newRating;
            writtenRatingSelectedList[i].isWrittenRated = true;
          } else {
            writtenRatingSelectedList[i].isWrittenRated = false;
          }
        }
      } else {
        writtenRatingSelectedList.push({
          skillId: id,
          ratingWritten: newRating,
          isWrittenRated: true,
        });
      }
    } else {
      writtenRatingSelectedList.push({
        skillId: id,
        ratingWritten: newRating,
        isWrittenRated: true,
      });
    }
    setRatingWriteSelectedList(writtenRatingSelectedList);

    if (ratingSpokenSelectedList.length > 0) {
      const ratingList = [...ratingSpokenSelectedList];
      for (let i = 0; i < ratingList.length; i++) {
        ratingList[i].isSpokenRated = false;
      }
      setRatingSpokenSelectedList(ratingList);
    }

    filteredCategories[index].ratingWritten = newRating;
    setFilteredCategories(filteredCategories);
  };

  const saveCandidateLanguages = () => {
    const langSelectedList = [];
    for (let i = 0; i < selectedSoftSkills.length; i++) {
      if (
        selectedSoftSkills[i].spoken != null &&
        selectedSoftSkills[i].written == null
      ) {
        if (selectedSoftSkills[i].spoken == true) {
          const skill = selectedSoftSkills[i];
          skill.ratingWritten = 0;

          for (let j = 0; j < ratingSpokenSelectedList.length; j++) {
            if (ratingSpokenSelectedList[j].skillId == skill.skillId) {
              skill.ratingSpoken = ratingSpokenSelectedList[j].ratingSpoken;
              break;
            }
          }
          langSelectedList.push(skill);
        }
      } else if (
        selectedSoftSkills[i].written != null &&
        selectedSoftSkills[i].spoken == null
      ) {
        if (selectedSoftSkills[i].written == true) {
          const skill = selectedSoftSkills[i];
          skill.ratingSpoken = 0;
          for (let j = 0; j < ratingWriteSelectedList.length; j++) {
            if (ratingWriteSelectedList[j].skillId == skill.skillId) {
              skill.ratingWritten = ratingWriteSelectedList[j].ratingWritten;
              break;
            }
          }
          langSelectedList.push(skill);
        }
      } else if (
        selectedSoftSkills[i].written != null &&
        selectedSoftSkills[i].spoken != null
      ) {
        if (
          selectedSoftSkills[i].spoken == true ||
          selectedSoftSkills[i].written == true
        ) {
          const skill = selectedSoftSkills[i];
          for (let j = 0; j < ratingSpokenSelectedList.length; j++) {
            if (ratingSpokenSelectedList[j].skillId == skill.skillId) {
              skill.ratingSpoken = ratingSpokenSelectedList[j].ratingSpoken;
              break;
            }
          }

          for (let j = 0; j < ratingWriteSelectedList.length; j++) {
            if (ratingWriteSelectedList[j].skillId == skill.skillId) {
              skill.ratingWritten = ratingWriteSelectedList[j].ratingWritten;
              break;
            }
          }
          langSelectedList.push(skill);
        }
      } else if (
        selectedSoftSkills[i].written == null &&
        selectedSoftSkills[i].spoken == null
      ) {
      }
    }

    if (langSelectedList.length > 0) {
      for (let i = 0; i < langSelectedList.length; i++) {
        if (langSelectedList[i].spoken !== null) {
          if (langSelectedList[i].spoken == true) {
            if (langSelectedList[i].ratingSpoken != null) {
              if (langSelectedList[i].ratingSpoken === 0) {
                Stringutility.showErrorMessage(Constants.rateSelectedLanguages);
                return;
              }
            } else {             
              Stringutility.showErrorMessage(Constants.rateSelectedLanguages);
              return;
            }
          }
        }

        if (langSelectedList[i].written !== null) {
          if (langSelectedList[i].written == true) {
            if (langSelectedList[i].ratingWritten != null) {
              if (langSelectedList[i].ratingWritten === 0) {              
                Stringutility.showErrorMessage(Constants.rateSelectedLanguages);
                return;
              }
            } else {
              Stringutility.showErrorMessage(Constants.rateSelectedLanguages);
              return;
            }
          }
        }
      }
    }
    const languageobject = {
      languages: langSelectedList,
    };

    if (langSelectedList.length > 0) {
      setSaveBtnEnabled(true);
      ProfileService.saveLanguages(languageobject).then((response) => {
        setSaveBtnEnabled(false);
        try {
          setSCategories([]);
          getCandidateLanguagesList();

          setModalRight(false);
          setSelectedSoftSkills([]);
        } catch (err) {
          console.error("saveLanguages" + JSON.stringify(err));
        }
      });
    } else {
      Stringutility.showErrorMessage(Constants.selectLanguage);
    }
  };

  const updateLanguagesRating = (languagesList) => {
    const languageobject = {
      languages: languagesList,
    };
    if (languagesList.length > 0) {
      setSaveBtnEnabled(true);
      ProfileService.saveLanguages(languageobject).then((response) => {     
        setSaveBtnEnabled(false)  
       });
    } else {
      Stringutility.showErrorMessage(Constants.selectLanguage);
    }
  };

  const searchItems = (searchValue) => {
    if (searchValue !== "") {
      if (searchValue.length >= 2) {
        JobService.searchLanguage(searchValue).then((response) => {
          try {
            var languageDetails = response.data;
            if (languageDetails != null) {
              if (languageDetails.skills.length > 0) {
                var languageSkills = languageDetails.skills;
                languageSkills.map((skill, index) => {
                  skill.ratingSpoken = 0;
                  skill.ratingWritten = 0;
                });
                setlanguageShow(true);
                updateLanguageSkills(languageSkills);
              } else {
                setFilteredCategories([]);
              }
            }
          } catch (err) {
            console.error("getProfileSkills" + JSON.stringify(err));
          }
        });
      } else {
        updateLanguageSkills(categories);
      }
    } else {
      updateLanguageSkills(categories);
    }
  };

  const updateLanguageSkills = (languageSkills) => {
    if (languageSkills.length > 0) {
      languageSkills.map((skill, index) => {
        if (ratingSpokenSelectedList.length > 0) {
          for (let i = 0; i < ratingSpokenSelectedList.length; i++) {
            var selectedSkillId = ratingSpokenSelectedList[i].skillId;
            var ratingSpoken = ratingSpokenSelectedList[i].ratingSpoken;
            if (skill.skillId == selectedSkillId) {
              skill.ratingSpoken = ratingSpoken;
            }
          }
        }

        if (ratingWriteSelectedList.length > 0) {
          for (let j = 0; j < ratingWriteSelectedList.length; j++) {
            var selectedSkillId = ratingWriteSelectedList[j].skillId;
            var ratingWritten = ratingWriteSelectedList[j].ratingWritten;
            if (skill.skillId == selectedSkillId) {
              skill.ratingWritten = ratingWritten;
            }
          }
        }
      });

      setFilteredCategories(languageSkills);
    } else {
      setFilteredCategories([]);
    }
  };

  const onAddLanguages = () => {
    setSelectedSpokenId([]);
    setSelectedWrittenId([]);
    setModalRight(true);
    setlanguageShow(true);
    setSaveBtnEnabled(false)
    resetSkillsListDetails();
  };

  const resetSkillsListDetails = () => {
    let categoriesList = [...categories];
    categoriesList.map((skill, index) => {
      skill.ratingSpoken = 0;
      skill.ratingWritten = 0;
    });
    updatedLanguageSkills(categoriesList);
  };

  const updatedLanguageSkills = (categoriesList) => {
    let updatedSpokenList = [];
    let updatedWrittenList = [];
    let selectedSpokenIdsList = [];

    let selectedSoftSkillsList = [];

    let ratingSpokengList = [];
    let ratingWrittenList = [];

    if (scategories.length > 0) {
      scategories.map((category, index) => {
        let skillId = category.skillId;
        let spoken = category.spoken;
        let written = category.written;
        let ratingSpoken = category.ratingSpoken;
        let ratingWritten = category.ratingWritten;

        selectedSoftSkillsList.push({
          skillId: skillId,
          spoken: spoken,
          written: written,
          ratingSpoken: ratingSpoken,
          ratingWritten: ratingWritten,
        });

        if (spoken) {
          updatedSpokenList.push(skillId);
          selectedSkills.push(skillId);
          ratingSpokengList.push({
            skillId: skillId,
            ratingSpoken: ratingSpoken,
          });
        }

        if (written) {
          updatedWrittenList.push(skillId);
          ratingWrittenList.push({
            skillId: skillId,
            ratingWritten: ratingWritten,
          });
        }

        const isFound = categoriesList.some((element) => {
          if (element.skillId === skillId) {
            selectedSpokenId.push({
              skillId: skillId,
            });
            return true;
          }
          return false;
        });

        if (isFound) {
          categoriesList.map((skill) => {
            let categorySKillId = skill.skillId;
            if (categorySKillId == skillId) {
              skill.ratingSpoken = ratingSpoken;
              skill.ratingWritten = ratingWritten;
            }
          });
        }
      });
    }
    setRatingSpokenSelectedList(ratingSpokengList);
    setRatingWriteSelectedList(ratingWrittenList);
    setSelectedSpokenId(selectedSpokenIdsList);
    setSelectedSkills(updatedSpokenList);
    setWrittenSelectedSkills(updatedWrittenList);
    setFilteredCategories(categoriesList);
    setSelectedSoftSkills(selectedSoftSkillsList);
  };

  const handledeletesoftskill = (skill) => {
    setLanguageId(skill.id);
    setLanguageName(skill.description);
    // setmodalNested(true)
    setSelectedLanguageId(skill.skillId);
    removeSkillDetails(skill.id);
  };
  const removeSkillDetails = (languageId) => {
    if (candidateTotLanguages.length > 0) {
      ProfileService.deleteProfileLanguage(languageId).then((response) => {
        try {
          setmodalNested(false);
          updateDetails();
          setSCategories([]);
          getCandidateLanguagesList();
          setmodalNested(false);
        } catch (err) {
          console.error("deleteProfileLanguage" + JSON.stringify(err));
        }
      });
    } else {
      Stringutility.showSuccessMessage(Constants.languageDeleted);
      setmodalNested(false);
      updateDetails();
      updateDetails();
      getCandidateLanguagesList();
    }
  };

  const updateDetails = () => {
    const languages = [];
    if (sessionStorage.getItem("removedLangList") !== null) {
      var retrievedData = sessionStorage.getItem("removedLangList");
      var removedList = JSON.parse(retrievedData);
      if (removedList.length > 0) {
        const data = [...removedList];
        const isFound = data.some((element) => {
          if (element === selectedLanguageId) {
            return true;
          }
          return false;
        });
        if (!isFound) {
          data.push(selectedLanguageId);
          sessionStorage.setItem("removedLangList", JSON.stringify(data));
        }
      } else {
        languages.push(selectedLanguageId);
        sessionStorage.setItem("removedLangList", JSON.stringify(languages));
      }
    } else {
      languages.push(selectedLanguageId);
      sessionStorage.setItem("removedLangList", JSON.stringify(languages));
    }
  };

  const back = () => {
    setmodalNested(false);
  };

  const handleCheck = (event, skill) => {};

  const showHorizontalLine = (skillLength, index) => {
    if (skillLength > 1 && index != skillLength - 1) {
      return <hr className="t-hr"></hr>;
    }
  };

  const updateLanguages = (skill) => {
    if (skill.ratingSpoken === 0 && skill.ratingWritten === 0) {    
      Stringutility.showErrorMessage(Constants.giveRatingForLanguages)
      return;
    }

    const langSelectedList = [];
    const langObj = {
      skillId: skill.skillId,
      ratingSpoken: skill.ratingSpoken,
      ratingWritten: skill.ratingWritten,
      spoken: skill.spoken,
      written: skill.written,
    };
    langSelectedList.push(langObj);
    const languageobject = {
      languages: langSelectedList,
    };

    ProfileService.saveLanguages(languageobject).then((response) => {
      setSaveBtnEnabled(false);
      try {
        Stringutility.showSuccessMessage(Constants.languageUpdatedSuccessfully);
        setSCategories([]);
        getCandidateLanguagesList();

        setSelectedSoftSkills([]);
      } catch (err) {
        console.error("saveLanguages" + JSON.stringify(err));
      }
    });
  };

  const languageSpokenRatingChanged = (newRating, skillId, index) => {
    let languages = [...scategories];
    languages.map((language) => {
      language.isWrittenRated = false;
      if (language.skillId == skillId) {
        language.ratingSpoken = newRating;
        language.isSpokenRated = true;
      } else {
        language.isSpokenRated = false;
      }
    });
    setSCategories(languages);
    updateLanguagesRating(languages)
  };

  const languageWrittenRatingChanged = (newRating, skillId, index) => {
    let languages = [...scategories];
    languages.map((language) => {
      language.isSpokenRated = false;
      if (language.skillId == skillId) {
        language.ratingWritten = newRating;
        language.isWrittenRated = true;
      } else {
        language.isWrittenRated = false;
      }
    });
    setSCategories(languages);
    updateLanguagesRating(languages)
  };

  const viewDetails = (skill) => {
    if (skill.ratingSpoken !== 0) {
      return (
      
          <TeamanicsButton
            color="primary"
            className="btn-sm ml-3"
            outline
            onClick={() => updateLanguages(skill)}
          >
            Save
          </TeamanicsButton>
        
      );
    } else if (skill.ratingWritten !== 0) {
      return (
     
          <TeamanicsButton
            color="primary"
            className="btn-sm ml-3"
            outline
            onClick={() => updateLanguages(skill)}
          >
            Save
          </TeamanicsButton>
       
      );
    } else {
      return <></>;
    }
  };

  const isSpokenRatingEditable = (skill) => {
    let editiable = true;

    if (skill.spoken) {
      editiable = true;
    } else {
      editiable = false;
    }

    return editiable;
  };

  const isWrittenRatingEditable = (skill) => {
    let editiable = true;
    if (skill.written) {
      editiable = true;
    } else {
      editiable = false;
    }
    return editiable;
  };

  const spokenRatingDialog = (skillId) => {
    var uniqueId = skillId;
    let ratingValue = 0;
    let isRated = false;
    if (ratingSpokenSelectedList.length > 0) {
      for (let i = 0; i < ratingSpokenSelectedList.length; i++) {
        if (ratingSpokenSelectedList[i].skillId == skillId) {
          ratingValue = ratingSpokenSelectedList[i].ratingSpoken;
          isRated = ratingSpokenSelectedList[i].isSpokenRated;
        }
      }
    } else {
      ratingValue = 0;
    }

    if (isRated) {
      if (ratingValue == 1) {
        $("#" + skillId + "spokenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Beginner";
      } else if (ratingValue == 2) {
        $("#" + skillId + "spokenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Intermediate";
      } else if (ratingValue == 3) {
        $("#" + skillId + "spokenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Proficient";
      } else if (ratingValue == 4) {
        $("#" + skillId + "spokenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Advanced";
      } else if (ratingValue == 5) {
        $("#" + skillId + "spokenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Expert";
      }
    }
  };

  const writtenRatingDialog = (skillId) => {
    var uniqueId = skillId;
    let ratingValue = 0;
    let isRated = false;
    if (ratingWriteSelectedList.length > 0) {
      for (let i = 0; i < ratingWriteSelectedList.length; i++) {
        if (ratingWriteSelectedList[i].skillId == skillId) {
          ratingValue = ratingWriteSelectedList[i].ratingWritten;
          isRated = ratingWriteSelectedList[i].isWrittenRated;
        }
      }
    } else {
      ratingValue = 0;
    }

    if (isRated) {
      if (ratingValue == 1) {
        $("#" + skillId + "writtenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Beginner";
      } else if (ratingValue == 2) {
        $("#" + skillId + "writtenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Intermediate";
      } else if (ratingValue == 3) {
        $("#" + skillId + "writtenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Proficient";
      } else if (ratingValue == 4) {
        $("#" + skillId + "writtenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Advanced";
      } else if (ratingValue == 5) {
        $("#" + skillId + "writtenRatingMessage")
          .fadeIn(1)
          .fadeOut(6000);
        return "Expert";
      }
    }
  };

  const spokenSkillRatingDialog = (skillId) => {
    var uniqueId = skillId;
    let ratingValue = 0;
    let isRated = false;
    if (scategories.length > 0) {
      for (let i = 0; i < scategories.length; i++) {
        if (scategories[i].skillId == skillId) {
          ratingValue = scategories[i].ratingSpoken;
          isRated = scategories[i].isSpokenRated;
          if (isRated) {
            scategories[i].isSpokenRated = false;
            if (ratingValue == 1) {
              $("#" + skillId + "spokenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Beginner";
            } else if (ratingValue == 2) {
              $("#" + skillId + "spokenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Intermediate";
            } else if (ratingValue == 3) {
              $("#" + skillId + "spokenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Proficient";
            } else if (ratingValue == 4) {
              $("#" + skillId + "spokenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Advanced";
            } else if (ratingValue == 5) {
              $("#" + skillId + "spokenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Expert";
            }
          }
        }
      }
    } else {
      ratingValue = 0;
    }
  };

  const writtenSkillRatingDialog = (skillId) => {
    var uniqueId = skillId;
    if (scategories.length > 0) {
      for (let i = 0; i < scategories.length; i++) {
        if (scategories[i].skillId == skillId) {
          let ratingValue = scategories[i].ratingWritten;
          let isRated = scategories[i].isWrittenRated;
          if (isRated) {
            scategories[i].isWrittenRated = false;
            if (ratingValue == 1) {
              $("#" + skillId + "writtenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Beginner";
            } else if (ratingValue == 2) {
              $("#" + skillId + "writtenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Intermediate";
            } else if (ratingValue == 3) {
              $("#" + skillId + "writtenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Proficient";
            } else if (ratingValue == 4) {
              $("#" + skillId + "writtenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Advanced";
            } else if (ratingValue == 5) {
              $("#" + skillId + "writtenSkillRatingMessage")
                .fadeIn(1)
                .fadeOut(6000);
              return "Expert";
            }
          }
        }
      }
    }
  };

  return (
    <div>
      <div>
        <Modal
          scrollable={true}
          isOpen={modalRight}
          toggle={() => setModalRight(!modalRight)}
          wrapClassName="modal-right"
          className="language-model-width "
        >
          <ModalHeader className="mdl_header">
            <div>
              <strong>Add and rate job languages</strong>
            </div>
          </ModalHeader>
          <ModalBody className="labelSize">
            <div className="col-lg-12 p-0 mb-3">
              <Input
                type="text"
                id="search"
                icon="search"
                placeholder="Search for languages"
                onChange={(e) => searchItems(e.target.value)}
              />
            </div>
            {languageshow && (
              <>
                {filteredCategories.length > 0 &&
                  filteredCategories.map((skill, index) => {
                    return (
                      <div className="col" key={skill.id+index}>
                        <label id="skillName">{skill.description}</label>
                       {" "}<i className="t-padding-left-wiz  ">
                        {skill.synonyms.length>0?(<>
                          {" "}{skill.synonyms}
                        </>):(<></>)}</i>
                        <div className="row">
                          <div className="col-xl-6 col-6 t-fold-lab">
                            <div className="tracbox ml-4">
                              <label>
                                <input
                                  data-testid="languagesist-privacypolicy"
                                  type="checkbox"
                                  className="input_skill"
                                  // checked={selectedSkills.find(
                                  //   (ch) => ch === skill.skillId
                                  // )}
                                  checked={selectedSkills.includes(skill.skillId)}
                                  onChange={(e) =>
                                    childSpokenHandleCheck(e, skill, index)
                                  }
                                />{" "}
                                Spoken
                              </label>
                            </div>
                          </div>

                          {selectedSkills.find((ch) => ch === skill.skillId) ? (
                            
                              <div className="ml-0 mr-0 col-xl-6 col-6 t-pad-star">
                                <div className="text-center items-center justify-center inline-block my-2 t-max-star-wid">
                                  <Row>
                                    {" "}
                                    <span>
                                      <Card className="star_bg_color col t-status-pad-star ">
                                        <ReactStars
                                          count={5}
                                          id={skill.skillId + "_spokenrating"}
                                          size={18}
                                          value={skill.ratingSpoken}
                                          activeColor="rgb(255, 188, 59)"
                                          onChange={(e) =>
                                            onSpokenRatingChanged(
                                              e,
                                              skill.skillId,
                                              index
                                            )
                                          }
                                        />
                                      </Card>
                                    </span>{" "}
                                    &nbsp;&nbsp;
                                    <span
                                      className="t-status-pad-st"
                                      id={skill.skillId + "spokenRatingMessage"}
                                    >
                                      {spokenRatingDialog(skill.skillId)}
                                    </span>
                                  </Row>
                                </div>
                              </div>
                          
                          ) : (
                            <></>
                          )}
                        </div>

                        <div className="row">
                          <div className="col-xl-6 col-6 t-fold-lab">
                            <div className="tracbox ml-4">
                              <label>
                                <input
                                  data-testid="languagesist-privacypolicy"
                                  type="checkbox"
                                  className="input_skill"
                                  // checked={writtenSelectedSkills.find(
                                  //   (ch) => ch === skill.skillId
                                  // )}
                                  checked={writtenSelectedSkills.includes(skill.skillId)}
                                  onChange={(e) =>
                                    childWrittenHandleCheck(e, skill, index)
                                  }
                                />{" "}
                                Written
                              </label>
                            </div>
                          </div>

                          {writtenSelectedSkills.find(
                            (ch) => ch === skill.skillId
                          ) ? (
                              <div className="ml-0 mr-0 col-xl-6 col-6 t-pad-star">
                                <div className="text-center items-center justify-center inline-block my-2 t-max-star-wid">
                                  <Row>
                                    <span>
                                      {" "}
                                      <Card className="star_bg_color col t-status-pad-star ">
                                        <ReactStars
                                          count={5}
                                          id={skill.skillId + "_writtenrating"}
                                          size={18}
                                          value={skill.ratingWritten}
                                          activeColor="rgb(255, 188, 59)"
                                          onChange={(e) =>
                                            onWriteRatingChanged(
                                              e,
                                              skill.skillId,
                                              index
                                            )
                                          }
                                        />
                                      </Card>
                                    </span>{" "}
                                    &nbsp;&nbsp;
                                    <span
                                      className=" t-status-pad-st"
                                      id={
                                        skill.skillId + "writtenRatingMessage"
                                      }
                                    >
                                      {writtenRatingDialog(skill.skillId)}
                                    </span>
                                  </Row>
                                </div>
                              </div>
                          
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    );
                  })}
                {filteredCategories.length == 0 && (
                  <div className="t-nodata">
                    <strong>Language not found</strong>
                  </div>
                )}
              </>
            )}
          </ModalBody>
          <ModalFooter className="p-4 t-modal-footer-btn">
            <TeamanicsButton onClick={() => setModalRight(false)}>Cancel</TeamanicsButton>
            <TeamanicsButton
              onClick={saveCandidateLanguages}
              disabled={saveBtnEnabled}
            >
              Save
            </TeamanicsButton>{" "}
          </ModalFooter>
        </Modal>
      </div>

      <Card className="mt-4 bg-primary-white min-sm:rounded-xl  pt-12 mb-5 p-3">
        <div className="profile-card-title row">
          <div className="col-6">
            <label>
              <strong>Languages</strong>
            </label>
          </div>

          <div className="col-sm-6 t-button-flex-end ">
            <TeamanicsButton
              className="btn-sm t-skill-btn"
              onClick={onAddLanguages}
            >
              {scategories.length >= 2 ? (
                <>Add more languages</>
              ) : (
                <>Add languages</>
              )}
            </TeamanicsButton>
          </div>
        </div>
        <p>Give 5 stars only on your top languages. </p>
        <CardBody className="t-body-padding[0px]">
          {scategories.length > 0 && (
            <>
              <div className="horizontal_line mt-1 mb-3" />
              {scategories.map((skill, index) => {
                return (
                  <div key={index}>
                    <Row >
                      <Colxx xxs="10">
                      <div className="col-sm-6">{skill.description}</div>
                        <Form>
                          <FormGroup row className="ml-3">
                            <div className="col-sm-5">
                              <Row>
                                <div className="col-lg-5 t-lang-lap-pad">
                                  <input
                                    data-testid="languagesist-privacypolicy"
                                    type="checkbox"
                                    className="input_skill  mr-1"
                                    checked={skill.spoken}
                                    onChange={(e) => handleCheck(e, skill)}
                                  />{" "}
                                  <Label className="mt-1 mr-1">Spoken</Label>
                                </div>
                                <div className="col-lg-7 t-lang-lap-pad">
                                  <div className="text-center items-center justify-center inline-block my-2">
                                    <Card className="star_bg_color col-12  ">
                                      <ReactStars
                                        count={5}
                                        size={16}
                                        value={skill.ratingSpoken}
                                        activeColor="rgb(255, 188, 59)"
                                        id={skill.id + "_spoken_rating"}
                                        // edit={skill.spoken}
                                        edit={isSpokenRatingEditable(skill)}
                                        onChange={(e) =>
                                          languageSpokenRatingChanged(
                                            e,
                                            skill.skillId,
                                            index
                                          )
                                        }
                                      />
                                    </Card>
                                    <span
                                      className="t-status-pad-st"
                                      id={
                                        skill.skillId +
                                        "spokenSkillRatingMessage"
                                      }
                                    >
                                      {spokenSkillRatingDialog(skill.skillId)}
                                    </span>
                                  </div>
                                </div>
                              </Row>
                            </div>

                            <div className="col-sm-5">
                              <Row>
                                <div className="col-lg-5 t-lang-lap-pad">
                                  <input
                                    data-testid="languagesist-privacypolicy"
                                    type="checkbox"
                                    className="input_skill mt-1 mr-1"
                                    checked={skill.written}
                                    onChange={(e) => handleCheck(e, skill)}
                                  ></input>{" "}
                                  <Label className="mt-1 mr-1">Written</Label>
                                </div>
                                <div className="col-lg-7 t-lang-lap-pad">
                                  <div className="text-center items-center justify-center inline-block my-2">
                                    <Card className="star_bg_color col-12  ">
                                      <ReactStars
                                        count={5}
                                        size={16}
                                        value={skill.ratingWritten}
                                        activeColor="rgb(255, 188, 59)"
                                        id={skill.id + "_written_rating"}
                                        edit={isWrittenRatingEditable(skill)}
                                        onChange={(e) =>
                                          languageWrittenRatingChanged(
                                            e,
                                            skill.skillId,
                                            index
                                          )
                                        }
                                      />
                                    </Card>
                                    {/* <span
                                      className="t-status-pad-st">
                                      Status
                                    </span> */}

                                    <span
                                      className="t-status-pad-st"
                                      id={
                                        skill.skillId +
                                        "writtenSkillRatingMessage"
                                      }
                                    >
                                      {writtenSkillRatingDialog(skill.skillId)}
                                    </span>
                                  </div>
                                </div>
                              </Row>
                            </div>
                          </FormGroup>
                        </Form>
                      </Colxx>

                      <Colxx xxs="2" className="mt-1">
                        <span to="">
                          <i
                            className="simple-icon-trash edit-copyiconsize arrow-icon-color emp_icon mt-1 t-padding-top "
                            color="black"
                            type="button"
                            title="Delete Language"
                            onClick={() => handledeletesoftskill(skill)}
                          />
                        </span>
                        {/* {viewDetails(skill)} */}
                      </Colxx>
                    </Row>
                    {showHorizontalLine(scategories.length, index)}
                  </div>
                );
              })}
            </>
          )}
        </CardBody>
      </Card>

      <Modal
        id="exampleModal"
        isOpen={modalNested}
        toggle={() => setmodalNested(!modalNested)}
        twrapClassName="modal-right"
        className="file-model-width"
        aria-hidden="true"
      >
        <ModalHeader>
          <div>
            <label className="modal-title" id="exampleModalLabel">
              <strong>Delete language</strong>
            </label>
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="modal-body">
            <label>
              Do you want to delete {" " + languageName + " "}
              language?
            </label>
          </div>
        </ModalBody>

        <ModalFooter className="model-button ">
          <div>
            <TeamanicsButton color="primary" outline data-dismiss="modal" onClick={back}>
              Close
            </TeamanicsButton>{" "}
            <TeamanicsButton
              color="primary"
              outline
              data-dismiss="modal"
              onClick={() => {
                removeSkillDetails();
              }}
            >
              Delete
            </TeamanicsButton>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default LanguagesList;
